import { RootState } from '../store'
import { UserState } from './types'

export const selectUser = (state: RootState): UserState => state.user

export const getUserId = (state: RootState): UserState['id'] => state.user.id
